import React, { useState, useContext } from "react";
import styled from "styled-components";
import BqnContext from "common/BqnContext";
import ModalsContext from "common/ModalsContext";
import Modal from "common/Modal";
import LoadingIcon from "common/Loading";
import ChooseInstance, { getSelectedBqn } from "views/Administration/common/ChooseInstance";

const FooterError = styled.div`
  width: 100%;
  text-align: left;
  margin-bottom: 10px;
  margin-left: 5px;
`;

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const Diagnostic = () => {
  const {
    bqnId,
    loginBqnId,
    clusterStatus: { mode },
  } = useContext(BqnContext);
  const { closeModal } = useContext(ModalsContext);
  const [errorFooter, setErrorFooter] = useState("");
  const [bqnSelected, setBqnSelected] = useState(getSelectedBqn(bqnId, loginBqnId));
  const [loading, setLoading] = useState(false);

  const onApply = () => {
    setErrorFooter("");
    const cmdBqn = mode === "cluster" ? ` bqn-id ${bqnSelected}` : "";
    setLoading(true);
    return ifCl
      .run(`system diagnostic${cmdBqn}`, {
        timeout: 600000,
      })
      .then((response) => {
        setLoading(false);
        if (
          response.match(/Permission denied/) ||
          response.match(/Operation not permitted/)
        ) {
          throw Error(`Operation not permitted`);
        } else {
          const matchResult = response.match(/diagnostic file:\s+(.*)/g);
          if (matchResult) {
            const [fileNameLine] = matchResult;
            const fileName = fileNameLine.split(/:\s+/)[1];
            getFile.execute(fileName, () => closeModal());
          } else {
            throw Error(`Something went wrong generating the diagnostic`);
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        setErrorFooter(`Error: ${error}`);
      });
  };

  return (
    <Modal
      title="Generate system diagnostic?"
      superIcon={"file_download"}
      onClose={() => closeModal()}
      closeLabel={loading ? null : "CANCEL"}
      applyLabel={loading || errorFooter ? null : "YES"}
      onApply={() => onApply()}
      content={() => (
        <div>
          <div>
            <strong>NOTE</strong>: Generating and downloading a diagnostic may
            take some time depending on the amount of data collected and the
            connection speed.
          </div>
          {mode === "cluster" ? (
            <div>
              <ChooseInstance action="diagnostic" selected={bqnSelected} setSelected={setBqnSelected}/>
            </div>
          ) : null}
          {loading ? (
            <LoadingWrapper>
              <LoadingIcon />
            </LoadingWrapper>
          ) : null}
        </div>
      )}
      footerMessage={
        errorFooter ? (
          <FooterError className="color-red">{errorFooter}</FooterError>
        ) : null
      }
    />
  );
};

export default Diagnostic;
